import React, { useContext } from 'react';
import { CurrentPageContext } from '../general-components/HistoryStackContext';

import { ReactComponent as IconB } from 'images/general/back.svg';
import { ReactComponent as IconX } from 'images/general/x.svg';

export default function CustomIconBack(props) {
    const p = useContext(CurrentPageContext);

    if ((p !== undefined) && (p.dontUseBackToDissmiss)) {
        return React.createElement(IconX, props);
    } else {
        return React.createElement(IconB, props);
    }
}